import { DEFAULT_PRODUCT_TYPE_DISCOUNT_RULES, PRODUCT_TYPE } from './constants';

function aggregateEligibility(items, rules) {
  return items.reduce(
    (acc, item) => {
      const itemRules = rules[item.productType] || rules[PRODUCT_TYPE.REGULAR];

      return {
        eligibleForPickup: acc.eligibleForPickup && itemRules.eligibleForPickup,
        eligibleForBonuses: acc.eligibleForBonuses && itemRules.eligibleForBonuses,
        eligibleForPromocodeStack:
          acc.eligibleForPromocodeStack && itemRules.eligibleForPromocodeStack,
      };
    },
    {
      eligibleForPickup: true,
      eligibleForBonuses: true,
      eligibleForPromocodeStack: true,
    },
  );
}

/**
 * Preliminary discount settings derived from cart composition and product types.
 * Does not replace backend pricing yet — prepares rules for future calculator logic.
 */
export function buildProductTypeDiscountSettings(
  compositionSummary,
  { stockCode, rules = DEFAULT_PRODUCT_TYPE_DISCOUNT_RULES } = {},
) {
  const { hasCombo, hasPromotional, items } = compositionSummary;
  const eligibility = aggregateEligibility(items, rules);

  return {
    rules,
    composition: {
      hasCombo,
      hasPromotional,
    },
    discounts: {
      pickup: {
        allowedByProductTypes: eligibility.eligibleForPickup,
        blockedByStock: Boolean(stockCode),
        allowed: eligibility.eligibleForPickup && !stockCode,
      },
      bonuses: {
        allowedByProductTypes: eligibility.eligibleForBonuses,
        allowed: eligibility.eligibleForBonuses,
      },
      promocode: {
        allowedByProductTypes: eligibility.eligibleForPromocodeStack,
        active: Boolean(stockCode),
      },
    },
  };
}
